/**
 * EmailIcon/index.js
 * desc: email icon
 * note: entity icon via IconButton; defaults its tooltip + accessible name to the
 *       icon label. Renders an accessible button when given an onClick handler.
 */
'use strict';

import IconButton from '../IconButton';
import { translate } from '../../../utilities/localization';


const EmailIcon = ({ tooltip, ...props }) => (
    <IconButton
        baseClassName="email icon"
        // accessible name follows the tooltip override so the visible tip + aria-label always match
        label={ tooltip || translate('icons.email.tooltip.text') }
        tooltip={ tooltip }
        { ...props }
    >
        <svg viewBox="0 0 20 16" xmlns="http://www.w3.org/2000/svg"><path d="M2 0h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H2c-1.1 0-2-.9-2-2L.01 2C.01.9.9 0 2 0zm8 9l8-5V2l-8 5-8-5v2l8 5z" /></svg>
    </IconButton>
);


export default EmailIcon;
